/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { PracticalExamShareTokenDto } from '../models';
// @ts-ignore
import type { PracticalExamSharedAttemptDto } from '../models';
/**
 * PracticalExamShareTokenApi - axios parameter creator
 * @export
 */
export const PracticalExamShareTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a public share token for an attempt (commission preview link)
         * @param {number} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPracticalExamShareToken: async (attemptId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('createPracticalExamShareToken', 'attemptId', attemptId)
            const localVarPath = `/api/v2/practical-exam-attempts/{attemptId}/share-tokens`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve a share token to a sanitized attempt view (no auth required)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePracticalExamShareToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('resolvePracticalExamShareToken', 'token', token)
            const localVarPath = `/api/v1/public/practical-exam-shares/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticalExamShareTokenApi - functional programming interface
 * @export
 */
export const PracticalExamShareTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticalExamShareTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a public share token for an attempt (commission preview link)
         * @param {number} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPracticalExamShareToken(attemptId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamShareTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPracticalExamShareToken(attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamShareTokenApi.createPracticalExamShareToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resolve a share token to a sanitized attempt view (no auth required)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolvePracticalExamShareToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamSharedAttemptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolvePracticalExamShareToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamShareTokenApi.resolvePracticalExamShareToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticalExamShareTokenApi - factory interface
 * @export
 */
export const PracticalExamShareTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticalExamShareTokenApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a public share token for an attempt (commission preview link)
         * @param {number} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPracticalExamShareToken(attemptId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamShareTokenDto> {
            return localVarFp.createPracticalExamShareToken(attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve a share token to a sanitized attempt view (no auth required)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolvePracticalExamShareToken(token: string, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSharedAttemptDto> {
            return localVarFp.resolvePracticalExamShareToken(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticalExamShareTokenApi - interface
 * @export
 * @interface PracticalExamShareTokenApi
 */
export interface PracticalExamShareTokenApiInterface {
    /**
     * 
     * @summary Create a public share token for an attempt (commission preview link)
     * @param {number} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamShareTokenApiInterface
     */
    createPracticalExamShareToken(attemptId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamShareTokenDto>;

    /**
     * 
     * @summary Resolve a share token to a sanitized attempt view (no auth required)
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamShareTokenApiInterface
     */
    resolvePracticalExamShareToken(token: string, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamSharedAttemptDto>;

}

/**
 * PracticalExamShareTokenApi - object-oriented interface
 * @export
 * @class PracticalExamShareTokenApi
 * @extends {BaseAPI}
 */
export class PracticalExamShareTokenApi extends BaseAPI implements PracticalExamShareTokenApiInterface {
    /**
     * 
     * @summary Create a public share token for an attempt (commission preview link)
     * @param {number} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamShareTokenApi
     */
    public createPracticalExamShareToken(attemptId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamShareTokenApiFp(this.configuration).createPracticalExamShareToken(attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve a share token to a sanitized attempt view (no auth required)
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamShareTokenApi
     */
    public resolvePracticalExamShareToken(token: string, options?: RawAxiosRequestConfig) {
        return PracticalExamShareTokenApiFp(this.configuration).resolvePracticalExamShareToken(token, options).then((request) => request(this.axios, this.basePath));
    }
}

